import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import Home from "./Home";
import Contacto from "./Contacto";
import Productos from "./Productos";

const App: React.FC = () => {
  return (
    <Router>
      {}
      <div
        style={{
          backgroundColor: "#a9d6f5",
          minHeight: "100vh",
          padding: "20px",
        }}
      >
        <Header />

        {}
        <h1
          style={{
            fontSize: "3rem",
            textAlign: "center",
            margin: "40px 0",
            color: "#ffffff",
            fontWeight: "900",
            letterSpacing: "3px",
            textTransform: "uppercase",
            fontFamily: "'Arial Black', Arial, sans-serif",
            textShadow:
              "0 0 5px #80c7ff, 0 0 10px #80c7ff, 0 0 15px #3399ff, 0 0 20px #007acc",
          }}
        >
          ¡Bienvenidos a NUESTRO RESTAURANTE, donde cada plato cuenta una
          historia peruana!
        </h1>

        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/contacto" element={<Contacto />} />
          <Route path="/productos" element={<Productos />} />
        </Routes>

        <Footer />
      </div>
    </Router>
  );
};

export default App;
